import { HttpClient } from '@wix/http-client';
import { InitialParams } from '@wix/wix-chatbot-common/browser';

import { renderModel } from '../util/renderModel';

const CLIENT_COOKIE_NAME = 'client-session-bind';
const CLIENT_HEADER = 'client-binding';

const { queryParams, authorizationToken } = renderModel.get();

const removeCookie = () => {
  const cookieParams = `${CLIENT_COOKIE_NAME}=; max-age=0; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT`;
  if (typeof location !== 'undefined') {
    const localUrl = new URL(location.href);
    const hostname = localUrl.hostname.includes('localhost') ? localUrl.hostname : `.${localUrl.hostname}`;
    document.cookie = `${cookieParams}; domain=${hostname}`;
  } else {
    document.cookie = cookieParams;
  }
};

export const STATUS = {
  OK: 200,
  CONFLICT: 409,
};

const headers: { [key: string]: any } = {
  'Content-Type': 'application/json',
};

if (queryParams['x-wix-route']) {
  const artifactRoutingParams =
    typeof queryParams['x-wix-route'] === 'object'
      ? Object.values(queryParams['x-wix-route'])
      : [queryParams['x-wix-route']];

  for (const routingParam of artifactRoutingParams) {
    const [artifact, wdpId] = String(routingParam).split(':');
    if (artifact && wdpId) {
      headers[`x-wix-route-${artifact}`] = wdpId;
    }
  }
}

if (authorizationToken) {
  headers.Authorization = authorizationToken;
}

function validateStatus(status: number) {
  return status === STATUS.OK || status === STATUS.CONFLICT;
}

const xsrfValue = document.cookie
  .split(';')
  .map((_) => _.trim())
  .filter((cookieName) => cookieName.startsWith(CLIENT_COOKIE_NAME))[0]
  ?.split('=')[1];

if (xsrfValue) {
  headers[CLIENT_HEADER] = xsrfValue;
  removeCookie();
}

export const baseURL = window.location.origin + (window.__BASEURL__ || '').replace(/\/$/, '');

let httpClientInstance: HttpClient;

export type HttpClientFactory = {
  getInstance: (params?: InitialParams) => HttpClient;
};

export const httpClient: HttpClientFactory = {
  getInstance: ({ authToken }: InitialParams = { authToken: '' }) => {
    if (!httpClientInstance) {
      httpClientInstance = new HttpClient({
        baseURL,
        validateStatus,
        headers,
        getAppToken: () => authToken,
      });
    }
    return httpClientInstance;
  },
};
